import React, { Component } from 'react';
import { connect } from "react-redux";

import "./style.scss";

// reactstrap imports
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators
} from 'reactstrap';

class ConnectedMainCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: Math.floor(Math.random() * 12),
      setActiveIndex: 0,
      animating: false,
      setAnimating: false
    }
    this.goToIndex = this.goToIndex.bind(this);
  }

  next() {
    const { activeIndex, animating } = this.state;
    const { games } = this.props;

    if (animating) return;
    const nextIndex = activeIndex === games.length - 1 ? 0 : activeIndex + 1;

    this.setState({
      activeIndex: nextIndex
    })
  }

  previous() {
    const { activeIndex, animating } = this.state;
    const { games } = this.props;

    if (animating) return;
    const nextIndex = activeIndex === 0 ? games.length - 1 : activeIndex - 1;

    this.setState({
      activeIndex: nextIndex
    })
  }

  goToIndex(newIndex) {
    const { animating } = this.state;
    if (animating) return;

    this.setState({
      activeIndex: newIndex
    })
  }

  setAnimating() {
    this.setState({
      setAnimating: !this.setAnimating
    })
  }

  render() {
    const { activeIndex } = this.state;
    const { games } = this.props;

    const slides = games.map((game) => {
      return (
        <CarouselItem
          onExiting={() => this.setAnimating()}
          onExited={() => this.setAnimating()}
          key={game.jaquette}
        >
          <img src={game.jaquette} alt={game.name} key={game.id} className="carousel-img" />
        </CarouselItem>

      );
    });

    return (
      <div>
        <Carousel
          activeIndex={activeIndex}
          next={() => this.next()}
          previous={() => this.previous()}
        >
          <CarouselIndicators items={games} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
          {slides}
          <CarouselControl direction="prev" directionText="Previous" onClickHandler={() => this.previous()} />
          <CarouselControl direction="next" directionText="Next" onClickHandler={() => this.next()} />
        </Carousel>
      </div>
    );
  }
}

const mstp = state => {
  return {
    games: state.gameInfo.game
  };
};

const MainCarousel = connect(
  mstp,
  null
)(ConnectedMainCarousel);

export default MainCarousel;
